import {
  withTranslation,
} from 'react-i18next';

import RegattaResultTableView from './RegattaResultTableView';
import './RegattaResultTable.css';

const TranslatedComponent = withTranslation()(RegattaResultTableView);

const Component = TranslatedComponent;

export default Component;
